module.exports = __webpack_public_path__ + "img/stopwatch.5dcad19d.svg";